import React from 'react';
import '../../styles/components/common/ScrollIndicator.css'

const ScrollIndicator = () => {
  return (
    <div className="hero-scroll-indicator">
      <div className="scroll-mouse">
        <div className="scroll-wheel"></div>
      </div>
      <span>Skrolujte za više</span>
    </div>
  );
};

export default ScrollIndicator;